import React from 'react';

import PeopleIcon from '@atlaskit/icon/glyph/people';
import GraphLineIcon from '@atlaskit/icon/glyph/graph-line';
import LockIcon from '@atlaskit/icon/glyph/lock';
import InviteTeamIcon from '@atlaskit/icon/glyph/invite-team';

import CheckCircleIconLight from '../assets/CheckCircleIconLight.svg';
import CheckCircleIconDark from '../assets/CheckCircleIconDark.svg';
import { BenefitIconStyled, CircleSvg } from '../styled/StyledModal';

const usingDarkMode = document.querySelector('html')?.dataset.colorMode === 'dark';

export const BenefitIcon = ({
	benefitTitle,
	usingBenefit,
}: {
	benefitTitle: string;
	usingBenefit?: boolean;
}) => {
	if (usingBenefit) {
		// this sucks and I'm sorry but it's the only way to use the gradient that Figma specifies
		return (
			<CircleSvg
				src={usingDarkMode ? CheckCircleIconDark : CheckCircleIconLight}
				alt="Using benefit"
			/>
		);
	}

	switch (benefitTitle) {
		case 'unlimited-users':
			return (
				<BenefitIconStyled>
					<PeopleIcon label="Unlimited Users" size="medium" />
				</BenefitIconStyled>
			);
		case 'page-insights':
			return (
				<BenefitIconStyled>
					<GraphLineIcon label="Page Insights" size="medium" />
				</BenefitIconStyled>
			);
		case 'page-restrictions':
			return (
				<BenefitIconStyled>
					<LockIcon label="Page Restrictions" size="medium" />
				</BenefitIconStyled>
			);
		case 'guest-access':
			return (
				<BenefitIconStyled>
					<InviteTeamIcon label="Guest Access" size="medium" />
				</BenefitIconStyled>
			);
		default:
			return <></>;
	}
};
